import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import UnifiedAcceptInvite from '@components/UnifiedAcceptInvite';

const MobileInviteAccept = (props: any) => {
  return <UnifiedAcceptInvite theme="light" />;
};

export default MobileInviteAccept;
